<template>
  <div>
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        
        <img ref="lazoRef" src="@/assets/lazo.avif" class="decoracion-sobres lazo-top" alt="Lazo Decorativo" />
        <img ref="estrellaTop1Ref" src="@/assets/estre.png" class="decoracion-sobres estrella-top-izq" alt="Estrella" />
        <img ref="estrellaTop2Ref" src="@/assets/estre.png" class="decoracion-sobres estrella-top-der" alt="Estrella" />
        <img ref="estrellaExtra1Ref" src="@/assets/estre.png" class="decoracion-sobres estrella-extra-1" alt="Estrella" />
        <img ref="estrellaExtra2Ref" src="@/assets/estre.png" class="decoracion-sobres estrella-extra-2" alt="Estrella Extra" />

        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Mesa de</span><br />
          <span class="script">Regalos</span>
        </h2>

        <p ref="textoRef" class="texto">
         Mi regalo favorito es que vengas a disfrutar conmigo,  ✨ <br />
          pero si deseas tener un detalle, lo recibiré con mucho cariño. 
        </p>

        <div class="seccion-regalo-bloque" ref="bloqueSobresRef">
          <div class="sobre-contenedor-wrap" ref="sobreContenedorRef">
            <img ref="sobreRef" :src="sobrePng" class="icono-sobre" alt="Sobre" />
          </div>
          <p ref="lluviaTextoRef" class="lluvia-texto">Lluvia de Sobres</p>
        </div>

        <div class="linea-divisoria" ref="linea1Ref"></div>

        <img ref="estrellaIntermediaRef" src="@/assets/estre.png" class="decoracion-sobres estrella-intermedia" alt="Estrella" />

        <div class="seccion-regalo-bloque" ref="bloqueLiverpoolRef">
          <div class="logo-regalo-wrap">
            <img src="@/assets/liverpool.png" class="logo-liverpool" alt="Liverpool" />
          </div>
          <a 
            href="https://mesaderegalos.liverpool.com.mx/milistaderegalos/52012478" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="btn-mesa-regalos"
          >
            Ir a Mesa <i class="fas fa-external-link-alt"></i>
          </a>
        </div>

        <div class="linea-divisoria" ref="linea2Ref"></div>

        <div class="seccion-regalo-bloque" ref="bloqueTarjetaRef">
          <div class="logo-regalo-wrap">
            <img src="@/assets/cred.png" class="logo-tarjeta" alt="Tarjeta Bancaria" />
          </div>
          <div class="datos-banco-card">
            <span class="banco-titular">Valentina </span>
            <span class="banco-nombre">Clabe BBVA</span>
            <span class="banco-numero">012 180 0155 5369 8095</span>
          </div>
        </div>

        <p ref="graciasRef" class="gracias">¡GRACIAS!</p>

        <div ref="discoGrandeRef" class="decoracion-sobres disco-avif-bottom-der">
          <img src="@/assets/bola.avif" alt="Bola de Disco Grande" class="bola-avif-media" />
        </div>

        <img ref="discoChicoRef" src="@/assets/bola1.avif" class="decoracion-sobres disco-png-bottom-izq" alt="Esfera Disco" />

        <img ref="estrellaBottom1Ref" src="@/assets/estre.png" class="decoracion-sobres estrella-bottom-izq-1" alt="Estrella" />
        <img ref="estrellaBottom2Ref" src="@/assets/estre.png" class="decoracion-sobres estrella-bottom-izq-2" alt="Estrella" />
        <img ref="estrellaBottom3Ref" src="@/assets/estre.png" class="decoracion-sobres estrella-bottom-der-3" alt="Estrella" />
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    // Adornos y contenedores
    const lazoRef = ref(null)
    const estrellaTop1Ref = ref(null)
    const estrellaTop2Ref = ref(null)
    const estrellaExtra1Ref = ref(null)
    const estrellaExtra2Ref = ref(null)
    const estrellaIntermediaRef = ref(null)
    const estrellaBottom1Ref = ref(null)
    const estrellaBottom2Ref = ref(null)
    const estrellaBottom3Ref = ref(null)
    const discoGrandeRef = ref(null)
    const discoChicoRef = ref(null)
    const sobreContenedorRef = ref(null)

    // Bloques estructurados
    const bloqueSobresRef = ref(null)
    const bloqueLiverpoolRef = ref(null)
    const bloqueTarjetaRef = ref(null)

    // Refs para las líneas divisorias
    const linea1Ref = ref(null)
    const linea2Ref = ref(null)

    let ctx; 

    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 12) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        el.style.position = 'absolute'
        el.style.width = '40px' 
        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.8)
        const rndDur = gsap.utils.random(2, 3)
        const xStart = lado === 'der' ? 100 : -20
        const xEnd = lado === 'der' ? -30 : 110

        gsap.fromTo(el,
          { xPercent: xStart, yPercent: -20, rotate: gsap.utils.random(-30, 30), opacity: 0, scale: 0.4 },
          {
            xPercent: xEnd,
            yPercent: 130,
            rotate: gsap.utils.random(100, 360),
            opacity: 0.8,
            scale: gsap.utils.random(0.5, 0.8),
            duration: rndDur,
            delay: rndDelay,
            ease: 'none',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      ctx = gsap.context(() => {
        // Inicializar estados ocultos
        gsap.set([
          lazoRef.value, estrellaTop1Ref.value, estrellaTop2Ref.value, estrellaExtra1Ref.value,
          estrellaExtra2Ref.value, estrellaIntermediaRef.value, estrellaBottom1Ref.value, 
          estrellaBottom2Ref.value, estrellaBottom3Ref.value, discoGrandeRef.value, discoChicoRef.value,
          bloqueSobresRef.value, bloqueLiverpoolRef.value, bloqueTarjetaRef.value,
          linea1Ref.value, linea2Ref.value
        ], { opacity: 0 })

        const tl1 = gsap.timeline({
          scrollTrigger: {
            trigger: raiz.value,
            start: "top 70%", 
            toggleActions: "play none none none",
            once: true
          }
        })

        // 1. Elementos superiores y estrellas
        tl1.fromTo(lazoRef.value, 
          { y: -45, opacity: 0, scale: 0.7 }, 
          { y: 0, opacity: 1, scale: 1, duration: 1.1, ease: "back.out(1.5)" }
        )
        .fromTo([estrellaTop1Ref.value, estrellaTop2Ref.value, estrellaExtra1Ref.value, estrellaExtra2Ref.value],
          { scale: 0, opacity: 0, rotation: -60 },
          { scale: 1, opacity: 0.8, rotation: 0, duration: 0.9, ease: "back.out(1.6)", stagger: 0.1 },
          "-=0.8"
        )
        // 2. Cabeceras
        .from([tituloRef.value.querySelector('.serif'), tituloRef.value.querySelector('.script')], {
          y: 50,
          opacity: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "back.out(1.7)"
        }, "-=0.5")
        .from(textoRef.value, { opacity: 0, y: 25, duration: 0.6 }, "-=0.5")
        
        // 3. Bloque 1 (Sobres)
        .fromTo(bloqueSobresRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.7 })
        
        // Animación de la línea 1 (Efecto de expansión desde el centro)
        .fromTo(linea1Ref.value, { opacity: 0, scaleX: 0 }, { opacity: 0.15, scaleX: 1, duration: 0.6, ease: "power2.out" }, "-=0.2")
        
        // Bloque 2 (Liverpool)
        .fromTo(bloqueLiverpoolRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.7 }, "-=0.2")
        
        // Animación de la línea 2
        .fromTo(linea2Ref.value, { opacity: 0, scaleX: 0 }, { opacity: 0.15, scaleX: 1, duration: 0.6, ease: "power2.out" }, "-=0.2")
        
        // Bloque 3 (Tarjeta)
        .fromTo(bloqueTarjetaRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.7 }, "-=0.2")
        
        // 4. Elementos decorativos inferiores e intermedios
        .fromTo(estrellaIntermediaRef.value, { scale: 0, opacity: 0 }, { scale: 1, opacity: 0.75, duration: 0.5 }, "-=0.5")
        .fromTo([discoGrandeRef.value, discoChicoRef.value],
          { scale: 0.2, y: 60, opacity: 0 },
          { scale: 1, y: 0, opacity: 1, duration: 1.2, ease: "back.out(1.4)", stagger: 0.15 },
          "-=0.6"
        )
        .fromTo([estrellaBottom1Ref.value, estrellaBottom2Ref.value, estrellaBottom3Ref.value],
          { scale: 0, opacity: 0, y: 20 },
          { scale: 1, opacity: 0.8, y: 0, duration: 0.8, ease: "power2.out", stagger: 0.1 },
          "-=0.7"
        )
        // 5. Cierre
        .from(graciasRef.value, { opacity: 0, scale: 0.8, duration: 0.5, ease: "back.out(1.5)" }, "-=0.2")
        .add(() => {
          crearLluvia(lluviaDer.value, 'der')
          crearLluvia(lluviaIzq.value, 'izq')
        }, "-=0.5")
        
        // 6. Loops de Flotación Infinita
        .add(() => {
          gsap.to([sobreRef.value, document.querySelector('.logo-liverpool'), document.querySelector('.logo-tarjeta')], {
            y: "+=6",
            duration: 2,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1,
            stagger: 0.25
          })
          gsap.to([
            estrellaTop1Ref.value, estrellaTop2Ref.value, estrellaExtra1Ref.value, 
            estrellaExtra2Ref.value, estrellaIntermediaRef.value, estrellaBottom1Ref.value, 
            estrellaBottom2Ref.value, estrellaBottom3Ref.value
          ], {
            scale: 1.15,
            rotation: "+=15",
            duration: 2.5,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1,
            stagger: 0.1
          })
          gsap.to(discoGrandeRef.value, {
            y: "-=6",
            rotation: 6,
            duration: 2.2,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
          })
          gsap.to(discoChicoRef.value, {
            y: "+=7",
            rotation: -7,
            duration: 1.9,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
          })
        })

      }, raiz.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert() 
    })

    return {
      raiz, tituloRef, textoRef, sobreRef, lluviaTextoRef, graciasRef,
      lluviaIzq, lluviaDer, sobrePng, lazoRef, estrellaTop1Ref, 
      estrellaTop2Ref, estrellaExtra1Ref, estrellaExtra2Ref, estrellaIntermediaRef,
      estrellaBottom1Ref, estrellaBottom2Ref, estrellaBottom3Ref,
      discoGrandeRef, discoChicoRef, sobreContenedorRef,
      bloqueSobresRef, bloqueLiverpoolRef, bloqueTarjetaRef,
      linea1Ref, linea2Ref
    }
  }
}
</script>

<style scoped>
.lluvia-sobres {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 65px 20px 85px;
  text-align: center;
  background: #fefefe;
  overflow: hidden;
  box-sizing: border-box;
}
.contenido { 
  position: relative; 
  z-index: 2;  
}

/* Tipografías */
.titulo {
  margin: 15px 0 10px;
  color: #010101;
  line-height: 1.05;
}
.titulo .serif {
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script {
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.texto {
  font-family: 'quote', serif;
  color: #010101;
  font-size: 16px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto 30px;
  opacity: .95;
}

/* Líneas divisorias horizontales refinadas */
.linea-divisoria {
  width: 75%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #000000, transparent);
  margin: 30px auto;
  opacity: 0.15;
  transform-origin: center;
}

/* Estructura para los bloques de regalos uniformes */
.seccion-regalo-bloque {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

/* Bloque 1: Sobres */
.sobre-contenedor-wrap {
  position: relative;
  display: inline-block;
  margin: 0 auto 8px;
}
.icono-sobre {
  width: 110px;
  height: auto;
  display: block;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
  will-change: transform;
}
.lluvia-texto {
  font-family: 'padres', serif;
  font-size: 19px;
  color: #010101;
  margin: 5px 0 0;
  letter-spacing: .05em;
  font-weight: 600;
}

/* Bloque 2: Liverpool */
.logo-regalo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 65px;
  margin-bottom: 12px;
}
.logo-liverpool {
  width: 170px;
  height: auto;
  object-fit: contain;
}
.btn-mesa-regalos {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #111111;
  color: #ffffff;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 11px 24px;
  border-radius: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, background-color 0.3s ease;
}
.btn-mesa-regalos:hover {
  transform: translateY(-2px);
  background-color: #e61972;
}

/* Bloque 3: Tarjeta */
.logo-tarjeta {
  width: 65px;
  height: auto;
  object-fit: contain;
}
.datos-banco-card {
  background: #fbfbfb;
  border: 1px solid #eeeeee;
  padding: 14px 25px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.02);
  min-width: 220px;
}
.banco-titular {
  font-family: 'quote', serif;
  font-size: 22px;
  color: #111111;

  font-weight: 800;
}
.banco-nombre {
  font-family: 'padres', sans-serif;
  font-size: 17px;
  text-transform: uppercase;
  color: #101010;
  font-weight: 600;
  letter-spacing: 1px;
}
.banco-numero {
  font-family: 'padres', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #004481;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* Footer */
.gracias {
  font-family: 'padres', serif;
  font-size: 24px;
  color: #010101;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 40px 0 0;
}

/* --- ADORNOS GRÁFICOS Y ESTRELLAS --- */
.decoracion-sobres {
  position: absolute;
  height: auto;
  pointer-events: none;
  will-change: transform, opacity;
}

.lazo-top {
  top: -90px !important;
  left: -95px !important;
  width: 125px;
  transform: scaleX(-1) !important;
  z-index: 3;
}

.estrella-top-izq {
  top: 25px !important;
  left: -5px;
  width: 72px;
  opacity: 0.8;
}

.estrella-top-der {
  top: -30px;
  right: 20px;
  width: 72px;
  opacity: 0.8;
}

.estrella-extra-1 {
  top: 180px !important;
  right: 10px;
  width: 50px;
  opacity: 0.75;
}

.estrella-extra-2 {
  top: 180px;
  left: 15px;
  width: 40px;
  opacity: 0.65;
}

.estrella-intermedia {
  top: 45%;
  right: 20px;
  width: 55px;
  opacity: 0.7;
}

.estrella-bottom-izq-1 {
  bottom: 50px;
  left: 12px;
  width: 0px;
  opacity: 0.8;
}

.estrella-bottom-izq-2 {
  bottom: 130px;
  left: -5px;
  width: 56px;
  opacity: 0;
}

.estrella-bottom-der-3 {
  bottom: 180px;
  right: 15px;
  width: 35px;
  opacity: 0.75;
}

/* Esferas de disco */
.disco-png-bottom-izq {
  bottom: -55px !important;
  left: -20px;
  width: 85px;
  opacity: 0 !important;
  z-index: 5;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.15));
}

.disco-avif-bottom-der {
  bottom: -95px;
  right: -15px;
  width: 135px;
  height: 135px;
  z-index: 3;
  overflow: hidden;
  clip-path: circle(50% at 50% 50%);
}
.bola-avif-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* --- LLUVIA DE SOBRES ANIMADA --- */
.lluvia {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq { left: 0; }
.lluvia-der { right: 0; }

.sobre-lluvia {
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

/* Ajustes Responsivos */
@media (max-width: 380px) {
  .titulo .serif { font-size: 46px; }
  .titulo .script { font-size: 38px; }
  .icono-sobre { width: 96px; }
  .logo-liverpool { width: 140px; }
  .disco-avif-bottom-der { width: 110px; height: 110px; bottom: -25px; }
  .linea-divisoria { width: 85%; margin: 25px auto; }
}
</style>